export default "__VITE_ASSET__DjNifqLj__"